import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";
import { FormGroup, FormGroupProps, FormGroupType } from "../misc/formGroup";

interface FormDatetimeProps extends Controls.ControlDatetimeProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    groupType?: FormGroupType | undefined;
}

const ComponentProps = (props: FormDatetimeProps): Controls.ControlDatetimeProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;

    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormDatetimeProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormDatetime: React.FC<Controls.ControlDatetimeProps> = (props) => {
    const styles: IFormStyles = useFormStyles();
    
    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlDatetime {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};